/** Pure branch-decision for the chats SPA shell view: the mission-control TABBED view or the assistant-ONLY view. Two
 *  independent inputs force assistant-only: the HOST mounts with the assistant initial-view data attribute, read at
 *  the mount path as `assistantOnly`; OR the shell user is not authorized for mission control. */

import { isAuthorizedForMissionControl } from '@federa/utils/auth/role-normalization-core';
import { KIND_ASSISTANT_ONLY, KIND_TABBED } from '@federa/const/spa-chats-kind-values';

/** Which chats shell to render, discriminated on `kind`. Local return-type of `resolveChatsView`; no cross-file consumer imports the name, so it stays file-local rather than migrating to the SSOT. The ARMS are not local: each is `typeof` its const, so the union cannot drift from the values the function actually returns. */
type ChatsViewResolution = { kind: typeof KIND_ASSISTANT_ONLY } | { kind: typeof KIND_TABBED };

/** Decide the chats shell from the host override plus the shell user's role. `assistantOnly` is `container.dataset.initialView === 'assistant'`, computed at the mount site; `role` is the raw shell-user role string. */
export function resolveChatsView(params: { assistantOnly: boolean; role: string | null | undefined }): ChatsViewResolution {
	if (params.assistantOnly || !isAuthorizedForMissionControl(params.role)) {
		return { kind: KIND_ASSISTANT_ONLY };
	}
	return { kind: KIND_TABBED };
}
